import React, {FC} from "react";
import {Controller} from "react-hook-form";
import MaterialCalendarPicker from "./MaterialCalendarPicker";
import dayjs from "dayjs";

interface FormMaterialCalendarPickerProps {
    control: any;
    name: string;
    label: string;
    format?: string;
    views?: ('day' | 'month' | 'year')[];
    disabled?: boolean;
    className?: string;
    startAdornmentIcon?: React.ReactNode;
}

export const FormMaterialCalendarPicker: FC<FormMaterialCalendarPickerProps> = (
    {
        format,
        name,
        label,
        control,
        views,
        disabled,
        className,
        startAdornmentIcon,
    }) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, ...rest }) => {
                return (
                    <MaterialCalendarPicker
                        views={views}
                        format={format}
                        label={label}
                        value={dayjs(field.value).isValid() ? field.value : undefined}
                        onChange={field.onChange}
                        error={rest.formState.errors[name]?.message as string || ''}
                        name={label}
                        disabled={disabled}
                        className={className}
                        startAdornmentIcon={startAdornmentIcon}
                     />
                )
            }}
        />
    );
};